import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ExclusionOtrosService } from './solicitud-otros.service';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { FileUploader } from "ng2-file-upload/ng2-file-upload";
import jQuery from "jquery";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { OtrosExclusionEntity } from "../entities/otros_exclusion_entity";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { JwtHelper } from "angular2-jwt/angular2-jwt";
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { correctHeight, detectBody } from "../../../app.helpers";

const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'exclusionOtros',
    providers: [],
    templateUrl: 'solicitud-otros.template.html'
})

export class ExclusionOtros implements OnChanges {

    usuario: ClienteLogin;
    public uploaderExc: FileUploader;
    public uploaderInc: FileUploader;
    public uploaderOtros: FileUploader;

    private url = "solicitudes";
    otrosEntity: OtrosExclusionEntity;
    devolverMensaje: any;
    jwtHelper: JwtHelper = new JwtHelper();
    @Input() polizaContratada: PolizaEntity;

    constructor(
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService

    ) {
        this.otrosEntity = new OtrosExclusionEntity();
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;

        this.uploaderInc = new FileUploader({
            url: this.url + '/incluirOtros',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderInc.options.headers = [];

        this.uploaderInc.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderInc.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 1);
        }

        this.uploaderExc = new FileUploader({
            url: this.url + '/excluirOtros',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderExc.options.headers = [];

        this.uploaderExc.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderExc.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 2);
        }

        this.uploaderOtros = new FileUploader({
            url: this.url + '/otrosMov',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderOtros.options.headers = [];

        this.uploaderOtros.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderOtros.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 3);
        }

        this.devolverMensaje = (parametro: number, tipoSolicitud: number): void => {

            let textoSolicitud = "";

            if (tipoSolicitud == 1)
                textoSolicitud = "inclusión";
            if (tipoSolicitud == 3)
                textoSolicitud = "otros movimientos";                
            if (tipoSolicitud == 2)
                textoSolicitud = "exclusión";


            if (parametro == 200) {
                swal({
                    title: 'Solicitud de ' + textoSolicitud + ' de bien asegurado',
                    text: 'Su solicitud ha sido enviada exitosamente. En breve, un ejecutivo se comunicará con ud. para concluir el proceso.',
                    type: 'success',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                }).then(function () {
                    window.location.reload(true);
                });
            }
            else {
                swal({
                    title: 'Error en solicitud de ' + textoSolicitud,
                    text: 'No se pudo realizar el envío de la solicitud de ' + textoSolicitud + ', por favor vuelva a intentar. En caso de volver a presentarse el mismo mensaje repórtelo a su ejecutivo de cuenta.',
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            }

        }

    }

    uploadFilesInQueue(tipoSolicitud: number): void {

        if (tipoSolicitud == 1) //inclusión
        {
            if (this.uploaderInc.getNotUploadedItems().length == 1) {

                this.uploaderInc.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderInc.uploadItem(this.uploaderInc.getNotUploadedItems()[0]);
            } else if (this.uploaderInc.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderInc.clearQueue();
            }
        }
        if (tipoSolicitud == 3) //inclusión
        {
            if (this.uploaderOtros.getNotUploadedItems().length == 1) {

                this.uploaderOtros.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderOtros.uploadItem(this.uploaderOtros.getNotUploadedItems()[0]);
            } else if (this.uploaderOtros.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderOtros.clearQueue();
            }
        }
        if (tipoSolicitud == 2) { //exclusión
            if (this.uploaderExc.getNotUploadedItems().length == 1) {

                this.uploaderExc.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderExc.uploadItem(this.uploaderExc.getNotUploadedItems()[0]);
            } else if (this.uploaderExc.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderExc.clearQueue();
            }
        }

    }

    uploadAllFiles(tipoSolicitud: number): void {
        const xhr = new XMLHttpRequest();
        const form = new FormData();

        if (tipoSolicitud == 1) //inclusión
        {
            for (const fileItem of this.uploaderInc.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status, 1);
                }
            }).bind(this);
            xhr.open("post", this.url + '/incluirOtros', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");

            xhr.send(form);

        }

        if (tipoSolicitud == 2) //exclusión
        {
            for (const fileItem of this.uploaderExc.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status, 2);
                }
            }).bind(this);
            xhr.open("post", this.url + '/excluirOtros', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");
            xhr.setRequestHeader("Observaciones", this.otrosEntity.Observaciones + "");
            xhr.send(form);
        }
        if (tipoSolicitud == 3) //otros mov
        {
            for (const fileItem of this.uploaderOtros.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status, 2);
                }
            }).bind(this);
            xhr.open("post", this.url + '/otrosMov', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");
            xhr.setRequestHeader("Observaciones", this.otrosEntity.Observaciones + "");
            xhr.send(form);
        }

    };

    ngOnChanges(): void {

        /*correctHeight();
        detectBody();*/

        this.otrosEntity.CodigoCiudad = this.polizaContratada.CodigoCiudad;
        this.otrosEntity.CodigoCliente = this.polizaContratada.CodigoCliente;
        this.otrosEntity.CodigoPoliza = this.polizaContratada.CodigoPoliza;
        this.otrosEntity.RolEmpleado = this.polizaContratada.RolEmpleado;
        this.otrosEntity.CodigoRamo = this.polizaContratada.CodigoRamo;
        this.otrosEntity.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;

        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
            }
        }
    }
}







// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-otros.component.ts